// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const et: KnowledgePagesCopy = {
  knowledgePage: 'Teadmusleht',
  knowledgePages: 'Teadmuslehed',
  featureOffTitle: 'Teadmuslehed pole selles tööruumis lubatud.',
  featureOffBody: 'Ettevõtte kontekst ja allikad on endiselt jaotises Teadmised.',
  loadingPage: 'Lehe laadimine…',
  loadingSuggestion: 'Ettepaneku laadimine…',
  cancel: 'Tühista',
  tryAgain: 'Proovi uuesti',
  everyoneIn: 'Kõik ettevõttes {company}',
  yourCompany: 'teie ettevõtte',
  revision: 'Redaktsioon {n}',
  openRevision: 'Ava redaktsioon {n}',
  pageCount: 'one:leht|other:lehte',
  topicCount: 'one:teema|other:teemat',
  sectionCount: 'one:jaotis|other:jaotist',
  lineCount: 'one:rida|other:rida',
  documentCount: 'one:dokument|other:dokumenti',
  changeCount: 'one:muudatus|other:muudatust',
  newPageCount: 'one:uus leht|other:uut lehte',
  changedPageCount: 'one:muudetud leht|other:muudetud lehte',
  otherSectionCount: 'one:muu jaotis|other:muud jaotist',
  characterCount: 'one:märk|other:märki',
  diffStats: '{sections} muudetud · {added} lisatud · {removed} eemaldatud',
  diffMatchesBase: 'Pakutud tekst ühtib lähteredaktsiooniga.',
  diffIntroduction: 'Sissejuhatus',
  diffOtherUnchanged: '{sections} muutmata.',
  timeJustNow: 'just praegu',
  originImportedFrom: 'Imporditud asukohast {path}',
  originImportedFromCommit: 'Imporditud asukohast {path} @ {commit}',
  authorityApprovedInPoneva: 'Kinnitatud Ponevas',
  authorityImported: 'Imporditud',
  authorityInRepository: 'repositooriumis {canonicality}',
  authorityVerified: 'kontrollitud {date}',
  authorRepositoryImport: 'Import repositooriumist',
  authorSuggestedInChat: 'Pakutud vestluses',
  authorSuggestedInChatWith: 'Pakutud vestluses kasutajaga {name}',
  authorSuggestedBy: 'Pakkuja: {name}',
  authorSuggestedByApp: 'Pakkus ühendatud rakendus',
  authorSuggestedByColleague: 'Pakkus kolleeg',
  authorSuggestedByYou: 'Pakkusite teie',
  authorSuggestedOnBehalf: 'Pakkus {app} kasutaja {name} nimel',
  authorSuggestedByAppOnBehalf: 'Pakkus ühendatud rakendus kasutaja {name} nimel',
  authorSuggestedAndApproved: 'Pakkus ja kinnitas {name}',
  approverApprovedBy: 'kinnitas {name}',
  approverAppliedBy: 'rakendas {name}',
  kindCreatePage: 'Uus leht',
  kindUpdatePage: 'Pakutud muudatus',
  kindArchivePage: 'Arhiveerimine',
  statusConflict: 'Konflikt · leht muutus',
  statusPending: 'Ootab ülevaatust',
  statusApproved: 'Kinnitatud',
  statusRejected: 'Kõrvale jäetud',
  statusWithdrawn: 'Tagasi võetud',
  statusSuperseded: 'Asendatud',
  errRevisionConflict: 'See leht muutus ülevaatamise ajal.',
  errProposalChanged:
    'See ettepanek muutus ülevaatamise ajal. Vaadake enne otsustamist üle uusim versioon.',
  errPublishRequired:
    'Teadmiste muudatusi kinnitada ja lehti importida saavad ainult ettevõtte avaldajad.',
  errProposalLimit:
    'Teie ettevõttes ootab ülevaatust juba 200 ettepanekut. Vaadake mõni neist üle, enne kui teete uusi.',
  errAuthorLimit:
    'Teil ootab ülevaatust juba 50 ettepanekut. Oodake, kuni osa neist on otsustatud, või võtke mõni tagasi, enne kui teete uusi.',
  errImportProposalLimit:
    'See import lisaks ülevaatamiseks rohkem muudetud lehti, kui teie ettevõtte ülevaatusjärjekorda mahub (kuni 200). Otsustage jaotises Ülevaatamiseks mõned ettepanekud ja rakendage siis uuesti.',
  errImportChanged:
    'See pole import, mille üle vaatasite. Avage see uuesti ja vaadake enne rakendamist üle.',
  errImportItemNotFound: 'See dokument ei kuulu enam importi.',
  errIdempotencyConflict:
    'See ettepanek on juba teistsuguse sisuga saadetud. Laadige uuesti ja proovige veel kord.',
  errImportHashMismatch:
    'Üks selle hetktõmmise fail ei vasta salvestatud kontrollsummale. Looge hetktõmmis uuesti ja proovige veel kord.',
  errImportAlreadyApplied: 'See import on juba rakendatud.',
  errImportDiscarded: 'Sellest impordist loobuti. Valige hetktõmmise fail uuesti.',
  errImportDuplicateItem:
    'Selles hetktõmmises on sama dokument kaks korda. Looge hetktõmmis uuesti.',
  errInvalidImport:
    'Poneva ei saanud seda hetktõmmist vastu võtta. Looge see hetktõmmise skriptiga uuesti ja proovige veel kord.',
  errInvalidInput:
    'Poneva ei saanud neid andmeid vastu võtta. Kontrollige välju ja proovige uuesti.',
  errImportLimit:
    'Liiga palju importe on ette valmistatud, kuid rakendamata. Rakendage mõni või loobuge mõnest, enne kui uue ette valmistate.',
  errPageTooLarge: 'Üks leht on suurem kui 256 KB. Jagage see väiksemateks lehtedeks.',
  errTooManySections: 'Ühel lehel on üle 2000 pealkirja. Jagage see väiksemateks lehtedeks.',
  errPageLimit: 'Teie ettevõte on jõudnud 2000 teadmuslehe piirini.',
  errCollectionLimit: 'Teie ettevõte on jõudnud 100 teema piirini.',
  errProposalNotPending: 'See ettepanek on juba otsustatud. Näidatud olek on ajakohane.',
  errRequesterRemoved:
    'Ettepaneku teinud inimene ei kuulu enam sellesse ettevõttesse, seega ei saa seda kinnitada.',
  errRevisionAlreadyCurrent: 'See redaktsioon on juba praegune.',
  errPageArchived:
    'See leht arhiveeriti ülevaatamise ajal. Vaadake ettepanek enne otsustamist uuesti üle.',
  errAlreadyArchived: 'See leht on juba arhiveeritud.',
  errProposalForbidden: 'Selle saab tagasi võtta ainult ettepaneku teinud inimene.',
  errUnavailable: 'Teadmuslehed pole praegu saadaval.',
  errTimeout: 'Poneva vastamine võttis liiga kaua aega.',
  errItemTooLarge: '{path} on suurem kui 256 KB. Jagage see väiksemateks lehtedeks.',
  errItemTooManySections: 'Failis {path} on üle 2000 pealkirja. Jagage see väiksemateks lehtedeks.',
  errItemHashMismatch:
    '{path} ei vasta salvestatud kontrollsummale. Looge hetktõmmis uuesti ja proovige veel kord.',
  errNoLongerAvailable: 'See üksus pole teile enam saadaval.',
  errTooLargeToSend: 'See fail on saatmiseks liiga suur.',
  cardChecking: 'Oleku kontrollimine…',
  cardNotAvailable: 'Pole saadaval',
  cardStatusUnavailable: 'Olek pole saadaval',
  cardUnshowable: 'Seda pakutud teadmiste muudatust ei saanud kuvada.',
  cardEyebrow: 'Pakutud teadmiste muudatus',
  cardLabel: 'Pakutud teadmiste muudatus · {title}',
  cardMissing: 'See ettepanek pole teile enam saadaval.',
  cardUnknown:
    'Me ei saanud kontrollida, mis selle ettepanekuga toimub. Avage ülevaatus, et näha selle olekut.',
  cardCheckAgain: 'Kontrolli uuesti',
  cardReview: 'Vaata muudatus üle',
  statusLineApproved: 'Kinnitatud teadmine',
  readyCount: 'one:otsinguks valmis|other:otsinguks valmis',
  preparingCount: 'one:ettevalmistamisel|other:ettevalmistamisel',
  attentionCount: 'one:vajab tähelepanu|other:vajavad tähelepanu',
  topicsExplore: 'Uuri teemat',
  topicsAllPages: 'Kõik lehed',
  topicsOpenPages: 'Ava Lehed',
  topicsEmpty:
    'Kinnitatud lehti veel pole. Lehtedel on ettevõtte põhjalikud teadmised koos täieliku redaktsioonide ajalooga.',
  reviewsTitle: 'Pakutud lehemuudatused',
  reviewsTitleMine: 'Teie pakutud lehemuudatused',
  reviewsIntro:
    'Iga ettepanek on täielik redaktsioonikandidaat koos põhjenduse ja tõenditega. Midagi ei muutu enne, kui kinnitate just selle redaktsiooni.',
  reviewsIntroMine:
    'Teie ettepanekud ootavad siin, kuni ettevõtte avaldaja need üle vaatab. Seni jäävad lehed muutmata.',
  loadPagesFailed: 'Teadmuslehti ei õnnestunud laadida.',
  loadProposalsFailed: 'Pakutud lehemuudatusi ei õnnestunud laadida.',
  loadMoreFailed: 'Rohkem lehti ei õnnestunud laadida.',
  otherPages: 'Muud lehed',
  loadTopicFailed: 'Seda teemat ei õnnestunud laadida.',
  revisionShort: 'r{n}',
  updatedOn: 'Uuendatud {date}',
  emptyTitle: 'Teadmuslehti veel pole.',
  emptyBody:
    'Lehtedel on teie ettevõtte kinnitatud põhjalikud teadmised – suund, otsused ja töötavad – ning iga redaktsioon säilib. Importige repositooriumi hetktõmmisest või alustage lehte vestluses; avaldaja kinnitab iga lehe, enne kui see loeb ettevõtte teadmiseks.',
  importFromSnapshot: 'Impordi repositooriumi hetktõmmisest',
  startInChat: 'Alusta lehte vestluses',
  startInChatPrompt:
    'Aita mul luua meie ettevõttele teadmusleht. Küsi, mida see peaks käsitlema, ja ära mõtle sisu ise välja. See jääb ettepanekuks, kuni ettevõtte avaldaja selle kinnitab.',
  loadingPages: 'Teadmuslehtede laadimine…',
  filterLabel: 'Filtreeri lehti pealkirja järgi',
  filterPlaceholder: 'Filtreeri lehti',
  importButton: 'Impordi',
  showingTopic: 'Kuvatakse: {topic}',
  showAllTopics: 'Näita kõiki teemasid',
  loadingTopic: 'Teema laadimine…',
  noMatch: 'Päringule „{filter}“ ei vasta ükski leht.',
  topicNoPages: 'Selles teemas pole veel kinnitatud lehti.',
  loading: 'Laadimine…',
  loadMore: 'Laadi rohkem lehti',
  metaApproved: 'kinnitatud {date}',
  metaRepositoryAuthoritative: 'määrav on endiselt repositoorium',
  loadPageFailed: 'Seda lehte ei õnnestunud laadida.',
  loadHistoryFailed: 'Redaktsioonide ajalugu ei õnnestunud laadida.',
  outlineLabel: 'Lehe jaotised',
  outlineToggle: 'Sellel lehel',
  loadingHistory: 'Redaktsioonide ajaloo laadimine…',
  historyLabel: 'Redaktsioonide ajalugu',
  historyIntro:
    'Iga kinnitatud redaktsioon säilitatakse. Varasema taastamine loob ülevaatamiseks ettepaneku; hilisemaid redaktsioone see kunagi ei kustuta.',
  historyCurrent: 'Praegune',
  historyViewing: 'Vaatamisel',
  historyView: 'Vaata',
  historyViewAria: 'Vaata redaktsiooni {n}',
  restoreAria: 'Taasta ettepanekuna: redaktsioon {n}',
  restoreCreating: 'Ettepaneku loomine…',
  restore: 'Taasta ettepanekuna',
  restoreUnconfirmed:
    'Me ei saanud kinnitada, et ettepanek loodi. Kontrollige jaotist Ülevaatamiseks, enne kui uuesti proovite.',
  editTooLarge:
    'See leht on suurem kui 256 KB. Jagage see enne ettepaneku tegemist väiksemateks lehtedeks.',
  editConflict:
    'See leht muutus teie muutmise ajal. Kopeerige oma tekst, avage uusim redaktsioon ja pakkuge muudatust uuesti.',
  editUnconfirmed:
    'Me ei saanud kinnitada, et teie ettepanek saadeti. Kontrollige jaotist Ülevaatamiseks, enne kui selle uuesti saadate.',
  editHeading: 'Paku muudatust',
  editIntro:
    'Muudate redaktsiooni {n}. Ettevõtte avaldaja vaatab täpse muudatuse üle, enne kui sellest saab redaktsioon {next}; seni jääb leht muutmata.',
  editOutdated:
    'Teie muutmise ajal kinnitati uuem redaktsioon. Kopeerige oma tekst ja alustage uusimast redaktsioonist uuesti, et selle muudatused kaotsi ei läheks.',
  editContentLabel: 'Lehe sisu (Markdown)',
  editReasonLabel: 'Miks see muudatus?',
  editReasonPlaceholder: 'Mis muutus ja kust see pärineb.',
  editSending: 'Saatmine…',
  editSend: 'Saada ülevaatamiseks',
  editDiscardConfirm: 'Kas loobuda sellest muudatusest? Midagi teie muudetust pole saadetud.',
  editNoChanges: 'Muudatusi veel pole.',
  editNeedsContent: 'Lehel peab olema sisu.',
  exportFailed: 'Seda lehte ei õnnestunud eksportida. Proovige uuesti.',
  askPagePrompt: 'Küsimus teadmuslehe „{title}“ kohta (redaktsioon {n}, {link}):',
  askPageSectionPrompt:
    'Küsimus teadmuslehe „{title}“ § {section} kohta (redaktsioon {n}, {link}):',
  pageMissingTitle: 'See leht pole saadaval.',
  pageMissingBody:
    'See võidi arhiveerida või teil ei pruugi enam olla juurdepääsu selle ettevõtte teadmistele.',
  pageArchived: 'Arhiveeritud',
  viewingRevisionCurrent: 'Vaatate redaktsiooni {n}; praegune redaktsioon on {current}.',
  viewingRevisionOld: 'Vaatate redaktsiooni {n}. See pole praegune redaktsioon.',
  openCurrent: 'Ava praegune',
  archivedBanner:
    'See leht on arhiveeritud. Seda ei kasutata enam vastustes; selle ajalugu säilib.',
  pageViewsLabel: 'Lehe vaated',
  tabRead: 'Loe',
  tabHistory: 'Ajalugu',
  unknownSection: 'Lingitud jaotis ei kuulu sellesse redaktsiooni. Kuvatakse kogu leht.',
  askAboutPage: 'Küsi selle lehe kohta',
  exporting: 'Eksportimine…',
  exportMarkdown: 'Ekspordi Markdown',
  loadSuggestionFailed: 'Seda ettepanekut ei õnnestunud laadida.',
  evidenceSource: 'Allikas',
  evidenceFact: 'Ettevõtte kontekst',
  evidenceResult: 'Salvestatud töö',
  evidenceUrl: 'Veebileht',
  evidenceDecision: 'Otsus',
  evidenceReference: 'Viide',
  evidenceOpenPage: 'Ava teadmusleht',
  evidenceOpenSource: 'Ava allikas',
  evidenceOpenFact: 'Ava ettevõtte kontekst',
  evidenceOpenResult: 'Ava salvestatud töö',
  evidenceOpenUrl: 'Ava veebileht',
  evidenceOpenDecision: 'Ava otsus',
  evidenceOpenReference: 'Ava viide',
  evidenceDecisionNote: 'Salvestatud otsus. Ponevas pole midagi avada.',
  evidenceFactGone: 'Seda ettevõtte konteksti pole enam salvestatud.',
  evidencePageNoRevision: 'Sellel lehel pole avamiseks kinnitatud redaktsiooni.',
  evidencePrivateExcerpt: 'Privaatne tõend – jagati ainult ülaltoodud väljavõtet.',
  evidencePrivate: 'Privaatne tõend – selle sisu ei jagatud teiega.',
  evidenceHeading: 'Tõendid',
  evidenceNone: 'Tõendeid ei lisatud. Hinnake ülaltoodud põhjendust omaette.',
  changeAdded: 'Lisatud',
  changeRemoved: 'Eemaldatud',
  changeChanged: 'Muudetud',
  changeUnchanged: 'Muutmata',
  moreLineCount: 'one:rida veel|other:rida veel',
  moreUnchangedLineCount: 'one:muutmata rida veel|other:muutmata rida veel',
  unchangedLineCount: 'one:muutmata rida|other:muutmata rida',
  skipAdded: '{lines} – näha täielikus redaktsioonis',
  skipRemoved: '{lines} eemaldatud',
  cutUnchanged: '{lines} pole näidatud',
  cutChanged: '{lines} pole näidatud, {changes}. Vaadake neid täielikus redaktsioonis.',
  cutAddedRemoved: '{added} lisatud ja {removed} eemaldatud',
  cutAdded: '{added} lisatud',
  cutRemoved: '{removed} eemaldatud',
  lineAddedSr: 'Lisatud:',
  lineRemovedSr: 'Eemaldatud:',
  noLinesAdded: 'Uus jaotis. Selle tekst on allpool täielikus redaktsioonis.',
  noLinesRemoved: 'See jaotis eemaldataks lehelt.',
  noLinesChanged: 'See jaotis muutub. Selle tekst on allpool täielikus redaktsioonis.',
  diffHeading: 'Muudatused',
  outcomeArchived: 'Arhiveeritud.',
  outcomeArchivedBody:
    'Lehte {title} ei kasutata enam vastustes ja see on lehtede loendist eemaldatud. Selle redaktsioonid, see ettepanek ja otsus jäävad lehe ajalukku.',
  openArchivedPage: 'Ava arhiveeritud leht',
  outcomeApproved: 'Kinnitatud.',
  outcomeApprovedRevision: 'Redaktsioon {n} on nüüd lehe {title} kinnitatud versioon.',
  outcomeApprovedPlain: 'See ettepanek kinnitati.',
  outcomeRestored: 'Leht on tagasi lehtede loendis ja seda kasutatakse taas vastustes.',
  outcomeKept: 'Ettepanek, otsus ja kõik varasemad redaktsioonid jäävad lehe ajalukku.',
  openPage: 'Ava leht',
  outcomeDismissed: 'Kõrvale jäetud.',
  outcomeWithdrawn: 'Tagasi võetud.',
  outcomeSuperseded: 'Asendatud.',
  outcomeSupersededBody:
    'Uuem redaktsioon, ettepanek või repositooriumi import muutis selle ettepaneku aegunuks. Iseenesest ei muutnud see midagi.',
  outcomeUnchanged: 'Leht jääb muutmata.',
  approveNewPage: 'Kinnita uus leht',
  approveArchive: 'Kinnita arhiveerimine',
  approveRestoreRevision: 'Taasta ja kinnita redaktsioon {n}',
  approveRevision: 'Kinnita redaktsioon {n}',
  approveArchiveNote: 'Kinnitamisel arhiveeritakse see leht kõigi {company} liikmete jaoks.',
  approvePublishNote: 'Kinnitamisel avaldatakse see redaktsioon kõigile {company} liikmetele.',
  approvePublishEvidenceNote:
    'Kinnitamisel avaldatakse see redaktsioon ja ülal näidatud tõendite väljavõtted kõigile {company} liikmetele.',
  archivedTitle: 'See leht on arhiveeritud.',
  alreadyArchivedBody:
    'Kinnitamine ei muudaks midagi, seega saab selle ettepaneku ainult kõrvale jätta.',
  archivedRestoreBody:
    'Kinnitamine taastab lehe: see naaseb selle redaktsiooniga lehtede loendisse, otsingusse ja vastustesse.',
  staleRevisionAction: 'Võrdle uusima versiooniga',
  staleProposalTitle: 'See ettepanek muutus ülevaatamise ajal.',
  staleProposalAction: 'Vaata uusim versioon üle',
  staleArchivedTitle:
    'See leht arhiveeriti ülevaatamise ajal. Selle ettepaneku kinnitamine tooks lehe tagasi.',
  staleArchivedAction: 'Vaata uuesti üle',
  suggestionMissingTitle: 'See ettepanek pole saadaval.',
  suggestionMissingBody:
    'See võidi tagasi võtta või kuulub see kellelegi teisele ja seda pole ettevõtte ülevaatusele saadetud.',
  decideUnconfirmed:
    'Me ei saanud teie otsust kinnitada. Näidatud olek on Ponevast saadud uusim; kontrollige seda, enne kui uuesti proovite.',
  decideFailed: 'Teie otsust ei õnnestunud salvestada.',
  discussPrompt: 'Aita mul viimistleda lehe „{title}“ kohta pakutud teadmiste muudatust ({link}).',
  conflictBody:
    'See ettepanek kirjutati redaktsiooni {base} põhjal; praegune redaktsioon on {current}. Kinnitamine kirjutaks selle muudatuse üle, seega ei saa seda praegusel kujul kinnitada.',
  conflictBodyPlain:
    'See ettepanek kirjutati varasema redaktsiooni põhjal, seega ei saa seda praegusel kujul kinnitada.',
  openLatest: 'Ava uusim versioon',
  reworkInChat: 'Tööta vestluses ümber',
  factReason: 'Põhjendus',
  factNoReason: 'Põhjendust ei esitatud.',
  factAudience: 'Sihtrühm',
  factRevision: 'Redaktsioon',
  revisionNew: 'Uus leht, redaktsioon 1',
  revisionArchiveAfter: 'Arhiveerimine pärast redaktsiooni {n}',
  revisionWrittenAgainst:
    'Kirjutatud redaktsiooni {base} põhjal; praegune redaktsioon on {current}',
  revisionCurrentToProposed: 'Praegune redaktsioon {base} → pakutud redaktsioon {next}',
  revisionProposed: 'Pakutud redaktsioon {next}',
  proposedPage: 'Pakutud leht',
  archivingHeading: 'Mida arhiveerimine teeb',
  archivingBody:
    'Lehte ei kasutata enam vastustes ja see eemaldatakse lehtede loendist. Selle redaktsioonid ja see otsus säilivad.',
  noComparison: 'Selle ettepaneku jaoks pole jaotiste võrdlust saadaval.',
  showComplete: 'Näita täielikku redaktsiooni',
  approving: 'Kinnitamine…',
  dismissing: 'Kõrvalejätmine…',
  dismiss: 'Jäta kõrvale',
  withdrawing: 'Tagasivõtmine…',
  withdraw: 'Võta tagasi',
  editInChat: 'Muuda vestluses',
  waitingForPublisher: 'Ootab, et ettevõtte avaldaja selle üle vaataks.',
  snapshotTooLarge: 'See hetktõmmis on suurem kui 8 MB. Looge see vähemate dokumentidega.',
  snapshotNotSnapshot:
    'See fail pole teadmiste hetktõmmis. Valige JSON-fail, mille hetktõmmise skript kirjutas.',
  snapshotEmpty: 'Selles hetktõmmises pole dokumente.',
  readDocumentFailed: 'Seda dokumenti ei õnnestunud lugeda. Proovige uuesti.',
  readingDocument: 'Dokumendi lugemine…',
  hideText: 'Peida tekst',
  readText: 'Loe teksti',
  textOf: 'Lehe {title} tekst',
  gitSnapshot: 'Giti hetktõmmis {commit}',
  repositorySnapshot: 'Repositooriumi hetktõmmis',
  importNewHeading: '{pages} · kinnitatakse rakendamisel',
  importNewNote:
    'Iga leht avaldatakse kinnitatud lehena kõigile ettevõttes {company}, ilma täiendava ülevaatuseta. Lugege iga leht enne rakendamist läbi.',
  importChangedHeading: '{pages} · saadetakse ülevaatamiseks',
  importChangedNote:
    'Igaühest saab pakutud muudatus. Selle leht muutub alles siis, kui avaldaja selle jaotises Ülevaatamiseks kinnitab; seal on näha, mis muutus.',
  unchangedDocumentCount: 'one:muutmata dokument|other:muutmata dokumenti',
  unchangedNote: 'Need vastavad juba oma kinnitatud lehtedele. Nende jaoks ei kirjutata midagi.',
  stagedHeading: 'Ette valmistatud, kuid rakendamata',
  excludedSummary: '{documents} jäeti sellest hetktõmmisest välja',
  countsLine: '{newPages} · {changedPages} ülevaatamiseks · {unchanged} muutmata',
  importAlreadyDiscarded: 'Sellest impordist on juba loobutud.',
  confirmLabel: 'Kinnita import',
  unchangedKeepCount:
    'one:muutmata dokument säilitab oma lehe|other:muutmata dokumenti säilitavad oma lehed',
  confirmBody:
    'Kas rakendada see import kõigile ettevõttes {company}? {newPages}: kinnitatakse redaktsioonina 1; {changedPages}: ootavad ülevaatust; {unchanged}. Nende lehtede varasemad impordiettepanekud võetakse tagasi.',
  applying: 'Rakendamine…',
  applyImport: 'Rakenda import',
  chooseAnother: 'Vali teine fail',
  allCurrent: 'Kõik selles hetktõmmises on juba ajakohane.',
  importApplied: 'Import rakendatud.',
  appliedSummary: 'Loodud: {pages} · ootab ülevaatust: {changes} · muutmata: {unchanged}.',
  appliedIndexing:
    'Uued lehed muutuvad vestluses otsitavaks, kui indekseerimine on lõppenud. Edenemist näitab jaotis Allikate ettevalmistamine.',
  openPages: 'Ava lehed',
  reviewChanges: 'Vaata üle: {changes}',
  checkIndexing: 'Kontrolli indekseerimise edenemist',
  sendSnapshotFailed: 'Seda hetktõmmist ei õnnestunud saata. Proovige uuesti.',
  openStagedFailed: 'Seda ettevalmistatud importi ei õnnestunud avada.',
  applyUnconfirmed:
    'Me ei saanud kinnitada, kas import rakendati. Kontrollige jaotist Lehed, enne kui uuesti proovite.',
  applyFailed: 'Seda importi ei õnnestunud rakendada.',
  importHeading: 'Impordi lehed repositooriumist',
  backToPages: 'Tagasi lehtede juurde',
  importLead:
    'Looge hetktõmmis käsuga {command} ja valige seejärel fail. Enne salvestamist näete iga dokumenti ja seda, mida see muudaks.',
  snapshotFileLabel: 'Teadmiste hetktõmmise fail',
  readingSnapshot: 'Hetktõmmise lugemine…',
  openingStaged: 'Ettevalmistatud impordi avamine…',
  chooseSnapshot: 'Vali hetktõmmise fail',
  factOrigin: 'Päritolu',
  factContents: 'Sisu',
  importOnlyListed: 'Imporditakse ainult siin loetletud dokumendid.',
  importRepositoryAuthoritative:
    'Määravaks jääb repositoorium; muudetud dokumentidest saavad ülevaatamiseks ettepanekud.',
  overviewReviewChanges: 'Vaata muudatused üle',
  overviewConnectAgents: 'Ühenda välised agendid',
  overviewEyebrow: 'Ühine arusaam',
  overviewTitle: '{company} kontekstis.',
  overviewLeadFallback:
    'Teie ettevõtte teadmised algavad kontekstist, mida jagate. Looge üheskoos arusaam oma äritegevusest.',
  overviewBody:
    'Ettevõtte kontekst ja lähtematerjal annavad Ponevale lähtepunkti – mitte kõike, mida ettevõtte {company} kohta teada on. Täiendage seda arusaama, kui teie äri areneb.',
  overviewAskPrompt: 'Mida sa meie ettevõtte kohta tead ja mida oleks kasulik lisada?',
  overviewAsk: 'Küsi ettevõtte {company} kohta',
  overviewAddSources: 'Lisa allikaid',
  contextEyebrow: 'Mis annab vastustele konteksti',
  contextTitle: 'Äri küsimuse taga.',
  contextBody:
    'Veebiallikad selgitavad avalikku äritegevust. Ettevõtte märkmed lisavad teie terminoloogia, prioriteedid ja töötavad.',
  contextPrompt:
    'Aita mul täpsustada ettevõtte prioriteete ja tööeelistusi, mida peaksime meeles pidama.',
  contextAction: 'Loo meie ühine arusaam',
  learnEyebrow: 'Ruumi õppida',
  learnTitle: 'Alustage sellest, mis on järgmisena oluline.',
  learnBody:
    'Tooge sisse lähtematerjali või täpsustage, kuidas teie ettevõte töötab. Poneva võib pakkuda püsivaid muudatusi, mille te üle vaatate.',
  learnPrompt:
    'Mis olulist teavet meie olemasolevatest ettevõtte teadmistest puudu on selle töö jaoks, mida tahame teha?',
  learnAction: 'Aruta, mis oleks kasulik',
  canvasEmptyTitle: 'Natuke konteksti aitab palju.',
  canvasEmptyBody:
    'Teie ettevõtte profiil on lähtepunkt. Lisage lähtematerjali ja üle vaadatud märkmeid, et aidata Poneval teie tööd mõista.',
  pageEyebrow: 'Ettevõtte {company} tööruum',
  pageTitle: 'Ettevõtte teadmised',
  pageDescription: 'Allikad ja arusaam, millele Poneva töö tugineb.',
  tabOverview: 'Ülevaade',
  tabPages: 'Lehed',
  tabSources: 'Allikad',
  tabReview: 'Ülevaatamiseks',
  proposalApproved: 'Kinnitatud ettevõtte kontekst',
  proposalDismissed: 'Kõrvale jäetud ettepanek',
  proposalRemoval: 'Pakutud eemaldamine',
  proposalCorrection: 'Pakutud parandus',
  proposalContext: 'Pakutud ettevõtte kontekst',
  proposalCurrent: 'Praegune arusaam',
  proposalFactGone:
    'Salvestatud fakt pole enam saadaval. Värskendage ettevõtte teadmisi, enne kui selle eemaldamise üle vaatate.',
  proposalReviewFallback: 'Vaadake pakutud ettevõtte kontekst üle.',
  proposalNotSaved: 'Pole veel salvestatud. Algsed allikad jäävad muutmata.',
  proposalWaiting: 'Ootab ülevaatust · avaldaja otsustab oma Postkastis',
  proposalSaving: 'Salvestamine…',
  proposalApproveRemoval: 'Kinnita eemaldamine',
  proposalApproveClarification: 'Kinnita täpsustus',
  factLabel: 'Ettevõtte fakt',
  factEyebrow: 'Fakt · Kõik ettevõttes {company}',
  factSuggestCorrection: 'Paku parandus',
  factAskPrompt: 'Aita mul mõista või täpsustada seda salvestatud ettevõtte konteksti: „{content}“',
  factAsk: 'Küsi selle kohta',
  companyContextHeading: 'Ettevõtte kontekst',
  companyContextPrompt:
    'Soovin meie ettevõtte teadmisi täpsustada. Aita mul üle vaadata, mida me teame, ja pakkuda välja uuendus.',
  companyContextEmpty:
    'Kinnitatud märkmeid veel pole. Alustage vestlust oma ettevõtte kohta või lisage allpool lähtematerjali.',
  refineInChat: 'Täpsusta vestluses',
  reviewPanelLabel: 'Ülevaatamist ootavad teadmiste muudatused',
  suggestedUpdatesHeading: 'Pakutud uuendused',
  suggestedUpdatesIntro:
    'Ettepanekud teie vestlustest. Teie otsustate, mis saab teie ettevõtte püsivate teadmiste osaks.',
  reviewEmptyTitle: 'Miski ei oota teie ülevaatust.',
  reviewEmptyBody:
    'Kui Poneva pakub teie ettevõtte teadmistesse muudatust, leiate selle siit. Püsivad muudatused vajavad alati teie kinnitust.',
  reviewEmptyPrompt:
    'Aita mul meie ettevõtte teadmised üle vaadata ja soovita, mida oleks järgmisena kasulik täpsustada.',
  inclusionPendingApproval: 'Teadmistesse kaasamise muudatus saadeti kinnitamiseks.',
  sourcesFileIncluded: 'Fail on kaasatud teadmiste otsingusse oma praegusele sihtrühmale.',
  sourcesAddFailed: 'Seda allikat ei õnnestunud lisada.',
  sourcesHeading: 'Materjal vastuste taga.',
  sourcesIntro:
    'Poneva otsib kogu lähtematerjalist, mitte ainult ülevaatest. Hoidke originaalid alles, vaadake, mis on valmis, ja valige, millele teie vastused tuginevad.',
  addSourceHeading: 'Lisage materjali oma ettevõttest',
  addSourceIntro:
    'Üles laaditud allikad jäävad teie Raamatukogus privaatseks ja toetavad ainult teie enda vastuseid. Valige Jaga, kui olete valmis need kolleegidele kättesaadavaks tegema.',
  uploadSource: 'Laadi allikas üles',
  addSourcePrompt:
    'Aita mul lisada ettevõtte avaldus jagatud sisemise allikana. Küsi, mida ma soovin kirja panna, ja ära mõtle sisu ise välja. Püsivad muudatused ettevõtte arusaamas vajavad endiselt minu kinnitust.',
  addThroughChat: 'Lisa vestluse kaudu',
  addingSource: 'Lisamine…',
  addToKnowledge: 'Lisa teadmistesse',
  uploadFormats: 'TXT, Markdown, CSV ja JSON · Kuni 5 MB faili kohta',
  sourceExcluded: 'Vastustest välja jäetud',
  sourcePreparationFailed: 'Ettevalmistamine ebaõnnestus',
  sourcePreparing: 'Otsinguks ettevalmistamisel',
  sourceWaiting: 'Ootab ettevalmistamist',
  sourceReadinessUnknown: 'Valmisolek pole teada',
  sourceRetryQueued: 'Ettevalmistamine on järjekorras. Valmisolek uueneb, kui see on lõppenud.',
  sourceIncludedNotice: 'Allikas on kaasatud. Poneva valmistab selle otsinguks ette.',
  sourceExcludedNotice: 'Vastustest välja jäetud. Algne allikas säilib.',
  sourceUpdateFailed: 'Seda allikat ei õnnestunud uuendada.',
  sourceOriginalMaterial: 'Algne lähtematerjal',
  sourceDiscuss: 'Aruta vestluses',
  sourceDiscussPrompt: 'Aita mul mõista või täpsustada allikat „{title}“.',
  sourceExclude: 'Jäta vastustest välja',
  sourceInclude: 'Kaasa vastustesse',
  sourcesLoadFailed: 'Teie allikaid ei õnnestunud laadida.',
  sourceLibraryLabel: 'Ettevõtte allikateek',
  sourceListCaption: 'Algsed allikad · kaasatud ja välja jäetud',
  sourceSearchLabel: 'Otsi ettevõtte allikatest',
  sourceSearchPlaceholder: 'Otsige oma allikatest…',
  sourcesFinding: 'Allikate otsimine…',
  sourcePagesLabel: 'Allikate lehed',
  sourceRange: '{from}–{to} / {count}',
  sourceCount: 'one:allikas|other:allikat',
  sourcePrevious: 'Eelmine',
  sourceNext: 'Järgmine',
  sourceNoMatchTitle: 'Sobivaid allikaid pole.',
  sourceNoMatchBody: 'Proovige teist fraasi või allika nime.',
  sourceEmptyTitle: 'Andke oma küsimustele tugevam lähtepunkt.',
  sourceEmptyBody:
    'Lisage ettevõtte dokumente, tooteandmeid või töömärkmeid. Poneva saab kasutada kogu lähtematerjali vestlustes ja Skillides.',
  indexCheckFailed: 'Allikate ettevalmistamist ei õnnestunud kontrollida.',
  indexRetryQueued:
    'Ebaõnnestunud teadmiste kirjed on ettevalmistamiseks järjekorda pandud. Teie lähtematerjal ei muutu.',
  indexQueueFailed: 'Ettevalmistamist ei õnnestunud järjekorda panna. Proovige uuesti.',
  indexPreparing: 'Uute teadmiste ettevalmistamine teie vestluste jaoks…',
  indexAttention: 'Osa teadmisi vajab tähelepanu.',
  queuing: 'Järjekorda panemine…',
  retryPreparation: 'Proovi ettevalmistamist uuesti',
  sourceKindStatement: 'Ettevõtte avaldus',
  sourceKindWebsite: 'Veebisait',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:vastus|other:vastust',
  factUsedThisWeek: 'Kasutatud sel nädalal: {answers}',
  factLastUsed: 'viimati kasutatud: {when}',
  factToday: 'täna',
  factYesterday: 'eile',
  factImpact: 'See muudatus mõjutab fakti, mida kasutati sel nädalal ({answers}).',
  factCorrectionAbout: 'Selle ettevõtte fakti kohta: „{content}“ ({link})',
  factCorrectionOutdated: 'See on aegunud:',
  sourceCanvasRecorded: 'Salvestatud lähtematerjal',
  sourceCanvasNotIncluded:
    'Ei kuulu ettevõtte teadmiste hulka. Originaal säilitatakse viitena ja seda saab endiselt kasutada konkreetses vestluses.',
  sourceCanvasOpenOriginal: 'Ava algne allikas',
  sourceCanvasUnavailable: 'Allika sisu pole saadaval.',
  sourceCanvasDiscussPrompt: 'Aita mul mõista või täpsustada allikat „{title}“.',
  sourceCanvasDiscuss: 'Aruta seda allikat',
  sourceCanvasCorrectionNote:
    'Parandusest saab pakutud ettevõtte kontekst. Salvestatud allikas jääb muutmata.',
  contextCanvasEyebrow: 'Saadaolev ettevõtte kontekst',
  contextCanvasTitle: 'Selle vestluse taga olevad teadmised.',
  contextCanvasBody:
    'Kinnitatud teadmised ja teie ettevõtte lisatud lähtematerjal. Saadaval vestluses ja tööriistas Skills.',
  contextCanvasOpen: 'Ava Teadmised',
};

export default et;
